import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  CardCVCElement,
  CardExpiryElement,
  CardNumberElement,
  injectStripe
} from "react-stripe-elements";
import { isEmpty } from 'ramda';

import Input from "../../../../common/components/Input";
import Button from "../../../../common/components/Button";
import request from "../../../../common/utils/request";
import Processing from "../UI/Processing";
import Error from "../UI/Error";


const STRIPE_ELEMENT_STYLES = {
  base: { fontSize: '15px', color: '#4a4a4a' },
  empty: {
    '::placeholder': {
      color: '#63646699',
    },
  },
};

function CreditCardForm({ onSave, onCancel, stripe }) {
  const [cardholderName, setCardholderName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSuccess = (response) => {
    switch(response.status) {
      case 'requires_action':
        stripe.confirmCardPayment(response.client_secret).then((result) => {
          if (result.error) {
            setError(result.error.message);
          }
          setLoading(false);
          onSave(response.card_details);
        });
        break;
      case 'fail':
        setError(response.error);
        setLoading(false);
        break;
      default: // 'active'
        onSave(response.card_details);
    }
  };

  const handleError = (response) => {
    setError('Something went wrong. Please, reload page.');
    setLoading(false);
  };

  const handleCancel = (event) => {
    event.preventDefault();
    onCancel();
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    setError('');

    stripe.createSource({
      type: 'card',
      owner: {
        name: cardholderName,
      },
    }).then((result) => {
      if (result.error) {
        setError(result.error.message);
        setLoading(false);
      } else {
        request('post', '/api/subscriptions/change_credit_card', { stripe_source_id: result.source.id })
          .then(handleSuccess)
          .catch(handleError);
      }
    })
  };

  return (
    <div className="form">
      <h3>Card details</h3>

      <div className="row">
        <div className="form-group col-md-6">
          <Input
            className="form-control"
            id="cardholderName"
            name="cardholderName"
            placeholder="Holder of card *"
            type="text"
            disabled={loading}
            onChange={e => {
              const { target: { value } } = e;
              setCardholderName(value)
            }}
          />
        </div>
      </div>

      <div className="row">
        <div className="form-group col-md-6">
          <CardNumberElement
            id="cardNumber"
            style={STRIPE_ELEMENT_STYLES}
            disabled={loading}
            className="form-control"
          />
        </div>
      </div>

      <div className="row">
        <div className="form-group col-md-3">
          <CardExpiryElement
            id="expiry"
            style={STRIPE_ELEMENT_STYLES}
            disabled={loading}
            className="form-control"
          />
        </div>

        <div className="form-group col-md-3">
          <CardCVCElement
            id="cvc"
            style={STRIPE_ELEMENT_STYLES}
            disabled={loading}
            className="form-control"
          />
        </div>
      </div>

      {loading &&
        <Processing />
      }

      {error &&
        <Error error={error}/>
      }

      <div className="row">
        <div className="form-group col-md-4 pull-left">
          <Button
            className="-empty"
            disabled={loading}
            onClick={handleCancel}
          >
            Cancel
          </Button>

          <Button
            type="submit"
            className="-primary"
            disabled={loading || isEmpty(cardholderName.trim())}
            onClick={handleSubmit}
          >
            Save
          </Button>
        </div>
      </div>
    </div>
  )
};

CreditCardForm.propTypes = {
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default injectStripe(CreditCardForm);


// WEBPACK FOOTER //
// ./app/javascript/components/card_details/components/CreditCard/Form.js